<template>
  <div
    class="banner"
    @touchstart.passive="handleTouchStart"
    @touchend.passive="handleTouchEnd"
  >
    <div class="banner__track" :style="{ transform: `translateX(-${activeIndex * 100}%)` }">
      <div
        v-for="(slide, index) in displayBanners"
        :key="slide.id || index"
        class="banner__slide"
        :class="{ 'banner__slide--active': index === activeIndex }"
      >
        <div class="banner__bg" :style="{ backgroundImage: `url(${slide.image || defaultImage})` }"></div>
        <div class="banner__content">
          <h1>{{ slide.title || '遵义市精科信检测有限公司' }}</h1>
          <p>{{ slide.subtitle || '专业的第三方检验检测机构' }}</p>
          <button class="banner__btn" @click.stop="goToAbout">了解更多</button>
        </div>
      </div>
    </div>
    <div class="banner__dots">
      <button
        v-for="(slide, index) in displayBanners"
        :key="slide.id || `dot-${index}`"
        class="banner__dot"
        @click.stop="goToSlide(index)"
      >
        <span
          v-if="index === activeIndex"
          :key="`progress-${index}-${progressSeed}`"
          class="banner__dot-progress"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
import defaultBannerImage from '@/assets/banners/banner1.png'

export default {
  name: 'Banner',
  props: {
    banners: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeIndex: 0,
      progressSeed: 0,
      autoPlayTimer: null,
      touchStartX: 0,
      defaultImage: defaultBannerImage
    }
  },
  computed: {
    displayBanners() {
      if (this.banners && this.banners.length > 0) {
        return this.banners
      }
      return [
        {
          id: 1,
          title: '遵义市精科信检测有限公司',
          subtitle: '专业的第三方检验检测机构',
          image: this.defaultImage
        }
      ]
    }
  },
  watch: {
    banners: {
      immediate: true,
      handler(newBanners) {
        const bannerCount = Array.isArray(newBanners) && newBanners.length > 0
          ? newBanners.length
          : 1

        if (this.activeIndex >= bannerCount) {
          this.activeIndex = 0
        }

        this.progressSeed += 1

        if (bannerCount > 1) {
          this.$nextTick(() => {
            this.startAutoPlay()
          })
        } else {
          this.stopAutoPlay()
        }
      }
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    nextSlide(isAuto = false) {
      this.activeIndex = (this.activeIndex + 1) % this.displayBanners.length
      this.progressSeed += 1
      if (!isAuto) {
        this.startAutoPlay()
      }
    },
    prevSlide() {
      this.activeIndex = (this.activeIndex - 1 + this.displayBanners.length) % this.displayBanners.length
      this.progressSeed += 1
      this.startAutoPlay()
    },
    goToSlide(index) {
      this.activeIndex = index
      this.progressSeed += 1
      this.startAutoPlay()
    },
    startAutoPlay() {
      this.stopAutoPlay()
      if (this.displayBanners.length <= 1) {
        return
      }
      this.autoPlayTimer = window.setInterval(() => {
        this.nextSlide(true)
      }, 5000)
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        window.clearInterval(this.autoPlayTimer)
        this.autoPlayTimer = null
      }
    },
    handleTouchStart(event) {
      if (!event.changedTouches || !event.changedTouches[0]) {
        return
      }
      this.touchStartX = event.changedTouches[0].clientX
    },
    handleTouchEnd(event) {
      if (!event.changedTouches || !event.changedTouches[0]) {
        return
      }
      const diffX = this.touchStartX - event.changedTouches[0].clientX
      if (Math.abs(diffX) < 40) {
        return
      }
      if (diffX > 0) {
        this.nextSlide()
      } else {
        this.prevSlide()
      }
    },
    goToAbout() {
      window.dispatchEvent(new CustomEvent('switchPage', {
        detail: { page: 'about' }
      }))
    }
  }
}
</script>

<style scoped>
.banner {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #fff;
}

.banner__track {
  height: 100%;
  display: flex;
  transition: transform 0.45s ease;
}

.banner__slide {
  position: relative;
  min-width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner__bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  transform: scale(1);
  will-change: transform;
}

.banner__slide--active .banner__bg {
  animation: bannerZoom 5s ease forwards;
}

.banner__content {
  max-width: 800px;
  padding: 0 20px;
  z-index: 2;
  text-align: center;
}

.banner__content h1 {
  font-size: 48px;
  margin-bottom: 20px;
  font-weight: 700;
}

.banner__content p {
  font-size: 20px;
  margin-bottom: 30px;
  opacity: 0.9;
}

.banner__btn {
  background-color: #fff;
  color: #007bff;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.banner__btn:hover {
  background-color: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.banner__dots {
  position: absolute;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 4;
}

.banner__dot {
  position: relative;
  width: 78px;
  height: 4px;
  border-radius: 2px;
  border: none;
  background-color: rgba(255, 255, 255, 0.28);
  cursor: pointer;
  overflow: hidden;
  padding: 0;
}

.banner__dot-progress {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  border-radius: 2px;
  background-color: #fff;
  animation: progressFill 5s linear forwards;
}

@keyframes progressFill {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes bannerZoom {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.08);
  }
}

@media (max-width: 768px) {
  .banner {
    min-height: 420px;
  }
  
  .banner__content h1 {
    font-size: 32px;
  }
  
  .banner__content p {
    font-size: 16px;
  }
  
  .banner__btn {
    padding: 10px 24px;
    font-size: 14px;
  }

  .banner__dot {
    width: 56px;
  }
}
</style>
